<template>
  <div class="flex flex-col">
    <!-- Header -->
    <div class="flex items-center justify-between mb-3 pb-2 border-b border-gray-200">
      <h2 class="text-sm font-semibold text-gray-800">Departments</h2>
      <button
        @click="openForm"
        class="btn-primary">
        <i class="fa fa-plus text-xs"></i>
        <span>Add Department</span>
      </button>
    </div>

    <!-- Table -->
    <div class="overflow-x-auto">
      <table>
        <thead>
          <tr>
            <th class="w-12">#</th>
            <th class="text-left">Department Name</th>
            <th class="w-32 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(department, idx) in departments" :key="department.id">
            <td class="text-center">{{ idx + 1 }}</td>
            <td class="font-medium capitalize">{{ department.departmentName }}</td>
            <td>
              <div class="flex items-center justify-center gap-1">
                <button
                  class="btn-sm-primary"
                  title="Edit Department">
                  <i class="fa fa-pencil"></i>
                </button>
                <button
                  class="btn-sm-danger"
                  title="Delete Department">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="departments.length === 0">
            <td colspan="3" class="text-center text-gray-500 py-3">
              <i class="fa fa-inbox text-2xl mb-2 block"></i>
              No departments found
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal -->
    <AppModal v-model="showAddDepartment" title="Add Department" hide-footer>
      <new-department />
    </AppModal>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { useConfigurationsStore } from "../../../stores";
import AppModal from "@/components/ui/AppModal.vue";
import NewDepartment from "@/domains/home/services/configurations/views/settings/departments/NewDepartment.vue";

// Types
interface Department {
  id: number
  departmentName: string
  [key: string]: any
}

// Store
const store = useConfigurationsStore();

// Reactive state
const showAddDepartment = ref<boolean>(false)
const departments = ref<Department[]>([])

// Lifecycle
onMounted(() => {
  store.fetchDepartments();
})

// Methods
const openForm = () => {
  showAddDepartment.value = true
}

// Watch store for department updates
watch(
  () => store.departments,
  (newDepartments) => {
    if (newDepartments) {
      departments.value = newDepartments
    }
  },
  { immediate: true }
)
</script>

